import {
  BADGE_TYPE_ACTIVE,
  BADGE_TYPE_DANGER,
  BADGE_TYPE_DEFAULT,
  BADGE_TYPE_INFO,
  BADGE_TYPE_PRIMARY
} from '@/constants/theme.constants.js'

import {
  ROLE_ADMIN,
  ROLE_BUSINESS_MANAGER,
  ROLE_CONSULTANT,
  ROLE_DIVISION_HEAD,
  ROLE_RECRUITER,
  ROLE_RECRUITING_HEAD,
  ROLE_SALES_MANAGER
} from '@/constants/role.constants.js'

export const PROCESS_STATUS_CREATED = 'created'
export const PROCESS_STATUS_SENT = 'sent'
export const PROCESS_STATUS_ACCEPTED = 'accepted'
export const PROCESS_STATUS_REJECTED = 'rejected'
export const PROCESS_STATUS_REMINDER = 'reminder'
export const PROCESS_STATUS_SHARED = 'shared'
export const PROCESS_STATUS_GENERAL_INTERVIEW = 'interview'
export const PROCESS_STATUS_INTERVIEW1 = 'interview1'
export const PROCESS_STATUS_INTERVIEW2 = 'interview2'
export const PROCESS_STATUS_INTERVIEW3 = 'interview3'
export const PROCESS_STATUS_COMPANY_ACCEPTED = 'company_accepted'
export const PROCESS_STATUS_COMPANY_REJECTED = 'company_rejected'
export const PROCESS_STATUS_OFFERED = 'offered'
export const PROCESS_STATUS_ROCKED = 'rocked'
export const PROCESS_STATUS_NO_REPLY = 'no_reply'
export const PROCESS_STATUS_COMPANY_NO_REPLY = 'company_no_reply'
export const PROCESS_STATUS_COMPANY_REPLIED = 'company_replied'
export const PROCESS_STATUS_READ = 'read'
export const PROCESS_STATUS_SHARED_READ = 'shared_read'
export const PROCESS_STATUS_INACTIVE = 'inactive'
export const PROCESS_STATUS_TRIAL_DAY = 'trial_day'

export const PROCESS_STANDALONE_ACTION = 'standalone_action'

export const PROCESS_CANDIDATE_STATUS_NEW_OFFER = 'new_offer'
export const PROCESS_CANDIDATE_STATUS_APPLIED = 'applied'
export const PROCESS_CANDIDATE_STATUS_SHARED = 'shared'
export const PROCESS_CANDIDATE_STATUS_COMPANY_REPLIED = 'company_replied'
export const PROCESS_CANDIDATE_STATUS_COMPANY_ACCEPTED = 'company_accepted'
export const PROCESS_CANDIDATE_STATUS_INTERVIEW = 'interview'
export const PROCESS_CANDIDATE_STATUS_REJECTED = 'rejected'
export const PROCESS_CANDIDATE_STATUS_COMPANY_REJECTED = 'company_rejected'
export const PROCESS_CANDIDATE_STATUS_TRIAL_DAY = 'trial_day'
export const PROCESS_CANDIDATE_STATUS_OFFERED = 'offered'
export const PROCESS_CANDIDATE_STATUS_ROCKED = 'rocked'
export const PROCESS_CANDIDATE_STATUS_CLOSED = 'closed'

export const PROCESS_CANDIDATE_STATUSES_FINISHED = [
  PROCESS_CANDIDATE_STATUS_CLOSED,
  PROCESS_CANDIDATE_STATUS_REJECTED,
  PROCESS_CANDIDATE_STATUS_COMPANY_REJECTED
]

export const PROCESS_CANDIDATE_NEGATIVE_STATUSES = [
  PROCESS_CANDIDATE_STATUS_CLOSED,
  PROCESS_CANDIDATE_STATUS_REJECTED,
  PROCESS_CANDIDATE_STATUS_COMPANY_REJECTED
]

export const PROCESS_LAST_STATUSES = [
  PROCESS_STATUS_NO_REPLY,
  PROCESS_STATUS_COMPANY_NO_REPLY,
  PROCESS_STATUS_REJECTED,
  PROCESS_STATUS_COMPANY_REJECTED,
  PROCESS_STATUS_INACTIVE,
  PROCESS_STATUS_ROCKED
]

export const PROCESS_STATUSES = [
  PROCESS_STATUS_CREATED,
  PROCESS_STATUS_SENT,
  PROCESS_STATUS_READ,
  PROCESS_STATUS_NO_REPLY,
  PROCESS_STATUS_REJECTED,
  PROCESS_STATUS_ACCEPTED,
  PROCESS_STATUS_REMINDER,
  PROCESS_STATUS_SHARED,
  PROCESS_STATUS_SHARED_READ,
  PROCESS_STATUS_COMPANY_NO_REPLY,
  PROCESS_STATUS_COMPANY_REJECTED,
  PROCESS_STATUS_COMPANY_ACCEPTED,
  PROCESS_STATUS_COMPANY_REPLIED,
  PROCESS_STATUS_INTERVIEW1,
  PROCESS_STATUS_INTERVIEW2,
  PROCESS_STATUS_INTERVIEW3,
  PROCESS_STATUS_TRIAL_DAY,
  PROCESS_STATUS_OFFERED,
  PROCESS_STATUS_ROCKED,
  PROCESS_STATUS_INACTIVE
]

export const PROCESS_FILTER_STATUS_ACTION_REQUIRED = 'action_required'
export const PROCESS_FILTER_STATUS_ALL_ACTIVE = 'all_active'

export const PROCESS_FILTER_STATUS_ORDERED_LIST = [
  PROCESS_FILTER_STATUS_ACTION_REQUIRED,
  PROCESS_STATUS_SENT,
  PROCESS_STATUS_READ,
  PROCESS_STATUS_ACCEPTED,
  PROCESS_STATUS_SHARED,
  PROCESS_STATUS_SHARED_READ,
  PROCESS_STATUS_COMPANY_REPLIED,
  PROCESS_STATUS_COMPANY_ACCEPTED,
  PROCESS_STATUS_INTERVIEW1,
  PROCESS_STATUS_INTERVIEW2,
  PROCESS_STATUS_INTERVIEW3,
  PROCESS_STATUS_TRIAL_DAY,
  PROCESS_STATUS_OFFERED,
  PROCESS_STATUS_ROCKED,
  PROCESS_FILTER_STATUS_ALL_ACTIVE,
  PROCESS_STATUS_CREATED,
  PROCESS_STATUS_NO_REPLY,
  PROCESS_STATUS_COMPANY_NO_REPLY,
  PROCESS_STATUS_COMPANY_REJECTED,
  PROCESS_STATUS_REJECTED,
  PROCESS_STATUS_INACTIVE
]

export const PROCESS_ACTIVE_STATUSES = [
  PROCESS_STATUS_CREATED,
  PROCESS_STATUS_SENT,
  PROCESS_STATUS_READ,
  PROCESS_STATUS_ACCEPTED,
  PROCESS_STATUS_REMINDER,
  PROCESS_STATUS_SHARED,
  PROCESS_STATUS_SHARED_READ,
  PROCESS_STATUS_COMPANY_REPLIED,
  PROCESS_STATUS_COMPANY_ACCEPTED,
  PROCESS_STATUS_INTERVIEW1,
  PROCESS_STATUS_INTERVIEW2,
  PROCESS_STATUS_INTERVIEW3,
  PROCESS_STATUS_TRIAL_DAY,
  PROCESS_STATUS_OFFERED
]

export const PROCESS_ACTIVITY_TYPE_ACCEPTED_INVITATION = 'accepted_invitation'
export const PROCESS_ACTIVITY_TYPE_ACCEPTED_INVITATION_STATUS = 'accepted_invitation_status'
export const PROCESS_ACTIVITY_TYPE_SENT_INVITATION_STATUS = 'sent_invitation_status'
export const PROCESS_ACTIVITY_TYPE_SENT_LOGIN = 'sent_login'
export const PROCESS_ACTIVITY_TYPE_UPDATE_STATUS = 'update_status'
export const PROCESS_ACTIVITY_TYPE_CREATE = 'create'
export const PROCESS_ACTIVITY_TYPE_REMINDER_STATUS = 'reminder_status'

export const PROCESS_ACTIVITY_TYPES = [
  PROCESS_ACTIVITY_TYPE_ACCEPTED_INVITATION,
  PROCESS_ACTIVITY_TYPE_ACCEPTED_INVITATION_STATUS,
  PROCESS_ACTIVITY_TYPE_SENT_INVITATION_STATUS,
  PROCESS_ACTIVITY_TYPE_SENT_LOGIN,
  PROCESS_ACTIVITY_TYPE_UPDATE_STATUS,
  PROCESS_ACTIVITY_TYPE_CREATE,
  PROCESS_ACTIVITY_TYPE_REMINDER_STATUS
]

export const PROCESS_COMPANY_REJECTION_REASON_EXPERIENCE = 'experience'
export const PROCESS_COMPANY_REJECTION_REASON_EDUCATION = 'education'
export const PROCESS_COMPANY_REJECTION_REASON_INDUSTRY_KNOWLEDGE = 'industry_knowledge'
export const PROCESS_COMPANY_REJECTION_REASON_SALARY = 'salary'
export const PROCESS_COMPANY_REJECTION_REASON_REFERENCES = 'references'
export const PROCESS_COMPANY_REJECTION_REASON_SKILLS = 'skills'
export const PROCESS_COMPANY_REJECTION_REASON_OVER_QUALIFICATION = 'overqualification'
export const PROCESS_COMPANY_REJECTION_REASON_UNDER_QUALIFICATION = 'underqualification'
export const PROCESS_COMPANY_REJECTION_REASON_CUSTOM = 'custom_reason'

export const PROCESS_COMPANY_REJECTION_REASONS = [
  PROCESS_COMPANY_REJECTION_REASON_EXPERIENCE,
  PROCESS_COMPANY_REJECTION_REASON_EDUCATION,
  PROCESS_COMPANY_REJECTION_REASON_INDUSTRY_KNOWLEDGE,
  PROCESS_COMPANY_REJECTION_REASON_SALARY,
  PROCESS_COMPANY_REJECTION_REASON_REFERENCES,
  PROCESS_COMPANY_REJECTION_REASON_SKILLS,
  PROCESS_COMPANY_REJECTION_REASON_OVER_QUALIFICATION,
  PROCESS_COMPANY_REJECTION_REASON_UNDER_QUALIFICATION,
  PROCESS_COMPANY_REJECTION_REASON_CUSTOM
]

export const PROCESS_PROFILE_REJECTION_REASON_WORKING_LOCATION = 'working_location'
export const PROCESS_PROFILE_REJECTION_REASON_QUALIFICATIONS = 'qualifications'
export const PROCESS_PROFILE_REJECTION_REASON_COMPANY_PROFILE = 'company_profile'
export const PROCESS_PROFILE_REJECTION_REASON_ALREADY_APPLIED = 'already_applied'
export const PROCESS_PROFILE_REJECTION_REASON_CUSTOM = 'custom_reason'

export const PROCESS_PROFILE_REJECTION_REASONS = [
  PROCESS_PROFILE_REJECTION_REASON_WORKING_LOCATION,
  PROCESS_PROFILE_REJECTION_REASON_QUALIFICATIONS,
  PROCESS_PROFILE_REJECTION_REASON_COMPANY_PROFILE,
  PROCESS_PROFILE_REJECTION_REASON_ALREADY_APPLIED,
  PROCESS_PROFILE_REJECTION_REASON_CUSTOM
]

export const PROCESS_COMPANY_REPLY_TYPE_ARRANGE_CALLBACK = 'arrange_callback'
export const PROCESS_COMPANY_REPLY_TYPE_FURTHER_QUESTIONS = 'further_questions'

export const PROCESS_COMPANY_REPLY_TYPES = [
  PROCESS_COMPANY_REPLY_TYPE_ARRANGE_CALLBACK,
  PROCESS_COMPANY_REPLY_TYPE_FURTHER_QUESTIONS
]

export const CREATE_PROCESS_PERMITTED_ROLES = [
  ROLE_DIVISION_HEAD,
  ROLE_CONSULTANT,
  ROLE_RECRUITING_HEAD,
  ROLE_RECRUITER,
  ROLE_BUSINESS_MANAGER,
  ROLE_SALES_MANAGER,
  ROLE_ADMIN
]

export const PROCESS_STATUS_BADGES = {
  [PROCESS_STATUS_CREATED]: BADGE_TYPE_PRIMARY,
  [PROCESS_STATUS_ACCEPTED]: BADGE_TYPE_ACTIVE,
  [PROCESS_STATUS_COMPANY_ACCEPTED]: BADGE_TYPE_ACTIVE,
  [PROCESS_STATUS_INTERVIEW1]: BADGE_TYPE_INFO,
  [PROCESS_STATUS_INTERVIEW2]: BADGE_TYPE_INFO,
  [PROCESS_STATUS_INTERVIEW3]: BADGE_TYPE_INFO,
  [PROCESS_STATUS_SHARED]: BADGE_TYPE_PRIMARY,
  [PROCESS_STATUS_SHARED_READ]: BADGE_TYPE_PRIMARY,
  [PROCESS_STATUS_INACTIVE]: BADGE_TYPE_DANGER,
  [PROCESS_STATUS_ROCKED]: BADGE_TYPE_DEFAULT
}

export const ACTION_SHARE_WITH_CANDIDATE = 'share_with_candidate'
export const ACTION_SHARE_WITH_COMPANY = 'share_with_company'
export const ACTION_REJECT_CANDIDATE_AFTER_INTERVIEW = 'reject_candidate_after_interview'
export const ACTION_REJECT_CANDIDATE_BEFORE_INTERVIEW = 'reject_candidate_before_interview'
export const ACTION_INVITE_TO_INTERVIEW_WITH_DATES = 'invite_to_interview_with_dates'
export const ACTION_INVITE_TO_INTERVIEW_NO_DATES = 'invite_to_interview_no_dates'
export const SEND_REQUEST_INTERVIEW_TO_COMPANY = 'send_request_interview_to_company'
export const ACTION_SEND_INTERVIEW_APPROVAL_TO_CANDIDATE = 'send_interview_approval_to_candidate'
export const ACTION_SEND_INTERVIEW_REMINDER_TO_CANDIDATE = 'send_interview_reminder_to_candidate'
export const ACTION_SEND_INTERVIEW_APPROVAL_TO_COMPANY = 'send_interview_approval_to_company'
export const ACTION_SEND_INTERVIEW_REMINDER_TO_COMPANY = 'send_interview_reminder_to_company'
export const ACTION_SUCCESSFUL_PLACEMENT = 'successful_placement'

export const PROCESS_ACTION_ROUTES_PATH = {
  [ACTION_SHARE_WITH_CANDIDATE]: 'share-with-candidate',
  [ACTION_SHARE_WITH_COMPANY]: 'share-with-company',
  [ACTION_INVITE_TO_INTERVIEW_NO_DATES]: 'invite-to-interview-no-dates',
  [ACTION_INVITE_TO_INTERVIEW_WITH_DATES]: 'invite-to-interview-with-dates',
  [ACTION_REJECT_CANDIDATE_AFTER_INTERVIEW]: 'reject-candidate-after-interview',
  [ACTION_REJECT_CANDIDATE_BEFORE_INTERVIEW]: 'reject-candidate-before-interview',
  [ACTION_SUCCESSFUL_PLACEMENT]: 'successful-placement',
  [ACTION_SEND_INTERVIEW_APPROVAL_TO_CANDIDATE]: 'send-interview-approval-to-candidate',
  [ACTION_SEND_INTERVIEW_REMINDER_TO_CANDIDATE]: 'send-interview-reminder-to-candidate',
  [ACTION_SEND_INTERVIEW_APPROVAL_TO_COMPANY]: 'send-interview-approval-to-company',
  [ACTION_SEND_INTERVIEW_REMINDER_TO_COMPANY]: 'send-interview-reminder-to-company'
}
export const HAS_ACTIVE_PROCESS = ['with_process', 'without_process']
